import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useGlobalHelpState } from './help-context';
import { Help, HelpComponent } from './components/help/Help.js';
import { I18n } from 'aws-amplify';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { Sidebar } from 'primereact/sidebar';
import { Button } from 'primereact/button';
import { Menu } from 'primereact/menu';
import { Toast } from 'primereact/toast';


export const AppTopbar = (props) => {
    const helpState = useGlobalHelpState();
    const { signOut } = useAuthenticator((context) => [context.user]);
    const toast = useRef(null);
    const menuLeft = useRef(null);

    const items = [
        {
            label: I18n.get("help"),
            icon: 'pi pi-fw pi-info-circle',
            command: () => {
                helpState.set({ ...helpState.get(), show: true });
            }
        },
        {
            label: I18n.get("profile"),
            icon: 'pi pi-fw pi-user',
            command: () => {
                window.location.href = '/#/profile';
            }
        },
        {
            label: I18n.get("logout"),
            icon: 'pi pi-fw pi-power-off',
            command: () => {
                signOut();
            }
        }
    ];

    const getHelp = () => {
        if (helpState.get().help) {
            return React.createElement(HelpComponent[helpState.get().help]);
        }
        return (<></>);
    };

    useEffect(() => {
        if (!helpState.get().help) {
            helpState.set({ ...helpState.get(), help: Help.global });
        }
        //eslint-disable-next-line
    }, [helpState.get().show]);

    return (
        <div className="layout-topbar">
            {!props.showCgu && (<Sidebar position="right" onHide={() => helpState.hideHelp()} visible={helpState.showHelp()} modal={false} maskClassName="cdm-help-pnl">
                    {getHelp()}
                </Sidebar>
            )}

            <Link to="/" className="layout-topbar-logo">
                <img src={'/assets/layout/images/cdm_logo.svg'} alt="logo" />
            </Link>

            <button type="button" className="p-link  layout-menu-button layout-topbar-button" onClick={props.onToggleMenuClick}>
                <i className="pi pi-bars" />
            </button>

            {/*Desktop menu*/}
            <div className="hidden lg:block layout-topbar-menu">
                {items.map((item) => {
                    return (
                        <Button
                            key={item.label}
                            icon={item.icon}
                            onClick={item.command}
                            text
                            rounded
                            className="text-black-alpha-60 p-button-lg"
                            style={{ width: '4rem', height: '4rem' }}
                        />
                    )
                })}
            </div>
            {/*Mobile menu*/}
            <div className="lg:hidden layout-topbar-logo">
                <Menu model={items} popup ref={menuLeft} className="w-max" />
                <Toast ref={toast}></Toast>
                {<Button
                    icon="pi pi-ellipsis-v"
                    className="mr-2"
                    onClick={(event) => menuLeft.current.toggle(event)} aria-controls="popup_menu_left"
                    severity="secondary"
                    aria-haspopup
                    outlined
                    text
                />}
            </div>
        </div>
    );
}
